import api from '@common/api/index.js'

const state = {
  data: new Map(),
  lock: false
};
const mutations = {
  SET_POINT (state, data) {
    if (data instanceof Array && state.lock === false) {
      state.lock = true
      for (let i = 0; i < data.length; i++) {
        const dataItem = data[i]
        for (let j = 0; j < dataItem.data.length; j++) {
          const pointItem = dataItem.data[j]
          //key 的格式   计量点id|采集编码|采集编号
          if (pointItem) {
            const key = dataItem.measureId + "|" + pointItem.pointCode + "|" + pointItem.pointNumber
            state.data.set(key, pointItem.value)
          }
        }
      }
      state.lock = false
    }
  }
};
const actions = {};
const getters = {
  GET_POINT_CODE_NUM: (state) => (param) => {
    if (param) {
      const key = param.id + "|" + param.code + "|" + param.num
      const value = state.data.get(key)
      if (typeof (value) === "undefined") {
        return "-"
      }
      else {
        return parseFloat(value).toFixed(2)
      }
    } else {
      return "-"
    }
  }
};

// 不要忘记把state, mutations等暴露出去。
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}